// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"96734a1d","734":"fe8aec1e"}[chunkId] + ".chunk.css";
};